var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showQrcode,
            expression: "showQrcode"
          }
        ],
        staticClass: "garbage-qrcode"
      },
      [
        _c("div", [
          _c("img", { attrs: { src: "/static/images/2500/qrcode.jpg" } }),
          _vm._v(" "),
          _c("h5", [_vm._v("长按识别二维码")]),
          _vm._v(" "),
          _c("p", [_vm._v("进入第三方垃圾分类查询小程序")])
        ]),
        _vm._v(" "),
        _c("i", {
          on: {
            click: function($event) {
              return _vm.$store.commit("GARBAGE_QRCODE", false)
            }
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-711356c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-711356c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/garbageQrcode.vue
// module id = null
// module chunks = 